import React from "react";
import PartyPage from "@/pages/PartyPage";
export default function Suppliers() { return <PartyPage kind="suppliers" />; }
